import { useMemo } from 'react'
import { useAccount } from 'wagmi'
import { useSWRContract, UseSWRContractKey } from 'hooks/useSWRContract'
import BigNumber from 'bignumber.js'

// TODO: refactor as useTokenApprovalStatus for generic use

export const useCakeApprovalStatus = (spender, cakeContracts?) => {
  const { address: account } = useAccount()
  const { reader: cakeContract } = cakeContracts
  const key = useMemo<UseSWRContractKey>(
    () =>
      account && spender
        ? {
            contract: cakeContract,
            methodName: 'allowance',
            params: [account, spender],
          }
        : null,
    [account, cakeContract, spender],
  )
  const { data, mutate } = useSWRContract(key)
  return {
    isVaultApproved: data ? data.gt(0) : false,
    allowance: new BigNumber(data?.toString()),
    setLastUpdated: mutate,
  }
}

export default useCakeApprovalStatus
